export default "__VITE_ASSET__DRYWX93z__"